import { ParseAdapter } from "../abstract/ParseAdapter";


export interface Attributes {
    'Severity': [string];
    'Pièce': [string];
    "Faux Positif": [string];
}

export interface ValuesIaTag {
    label: string;
    options: [string];
}


export class iaTag extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get type(): string { return this.parseObject.get('type') }
    set type(value: string) { this.parseObject.set('type', value); }

    get label(): string { return this.parseObject.get('label') }
    set label(value: string) { this.parseObject.set('label', value); }

    get default(): boolean { return this.parseObject.get('default') }
    set default(value: boolean) { this.parseObject.set('default', value); }

    get attributes(): Attributes { return this.parseObject.get('attributes') }
    set attributes(value: Attributes) { this.parseObject.set('attributes', value); }

    get attributesValues(): ValuesIaTag[] { return this.parseObject.get('attributesValues') }
    set attributesValues(value: ValuesIaTag[]) { this.parseObject.set('attributesValues', value); }


}


// WEBPACK FOOTER //
// ./src/app/model/iaTag.model.ts